import React, { createContext, useReducer } from "react";

const initialState = {
  // Sales
  sales: [],
  filteredSales: [],
  filteredSalesProducts: [],

  // Sales Target
  salesTarget: [],
  filteredSalesTarget: [],

  // Products
  products: [],

  // Branches
  branches: [],
};

export const DataContext = createContext(initialState);

const reducer = (state, action) => {
  switch (action.type) {
    // Sales Data
    case "SALES_DATA":
      return {
        ...state,
        sales: action.payload,
      };

    // Sales Filtered Data
    case "UPDATE_FILTERED_SALES_DATA":
      return {
        ...state,
        filteredSales: action.payload,
      };

    // Sales_Products Filtered Data
    case "UPDATE_FILTERED_SALES_PRODUCTS_DATA":
      return {
        ...state,
        filteredSalesProducts: action.payload,
      };

    // Sales Target Data
    case "SALES_TARGET":
      return {
        ...state,
        salesTarget: action.payload,
      };

    // Sales Target Filtered Data
    case "UPDATE_FILTERED_SALES_TARGET":
      return {
        ...state,
        filteredSalesTarget: action.payload,
      };

    // Products Data
    case "PRODUCTS_DATA":
      return {
        ...state,
        products: action.payload,
      };

    // Branches Data
    case "BRANCHES_DATA":
      return {
        ...state,
        branches: action.payload,
      };

    default:
      return state;
  }
};

export const DataProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <DataContext.Provider value={{ state, dispatch }}>
      {children}
    </DataContext.Provider>
  );
};
